// @FIXME cannot authorized via querystring so we need custom component:
//      https://stackoverflow.com/a/41025457/1545769
import React, {
    Component
} from 'react'
import Skeleton from '@material-ui/lab/Skeleton'
import fetch from '~/utils/fetch'

window.PHOTO_REDIRECTS_CACHE = {}

export default class ImageCognitoSignedS3 extends Component {
    constructor() {
        super()
        this.state = {
            src: null,
            loading: true,
            width: null,
            height: null,
        }
    }

    async componentWillMount() {
    	this.setState({
    		width: this.props.width,
    		height: this.props.height,
    	})
    	this.fetchPhoto()
    }

    async componentDidUpdate(prevProps, prevState) {
    	if(this.props.signedUrlRedirect !== prevProps.signedUrlRedirect){
    		this.setState({
    			src: null,
    			loading: true,
    		})
    		await this.fetchPhoto();
    	}
    }

    async fetchPhoto() {
    	let src = PHOTO_REDIRECTS_CACHE[this.props.signedUrlRedirect] || null;
    	if(!src){
	        let response = await fetch({
	            url: this.props.signedUrlRedirect,
	            method: 'get'
	        })
	        src = response.result.signedUrl
	        PHOTO_REDIRECTS_CACHE[this.props.signedUrlRedirect] = src
	    }
        this.setState({
            src: src
        })
    }

    setLoaded() {
        this.setState({
            loading: false
        })
    }

    render() {
        return (
            <React.Fragment>
                <Skeleton
                    width={this.props.width}
                    height={this.props.height}
                    variant='rect'
                    style={{
                        display: this.state.src === null || this.state.loading === true ? 'block' : 'none',
                        width: this.props.width,
                        height: this.props.height,
                    }}
                />
                <img
                    onLoad={this.setLoaded.bind(this)}
                    src={this.state.src}
                    style={{
                        display: !this.state.loading ? 'block' : 'none',
                        width: 'auto',
                        height: this.props.height,
                        margin: '0 auto',
                    }}
                />
            </React.Fragment>
        )
    }
}